import { Typography } from '@upheal/design-system/components/Typography/Typography';
import { formatPriceWithCurrency } from '../utils/payments';
import { Skeleton } from '@mui/material';
import { lineHeightValues } from '@upheal/design-system/theme/design-system/tokens';

type Props = { discount: number; currency?: string; isLoading?: boolean };

export const DiscountCaption = ({
    discount,
    currency = 'USD',
    isLoading = false,
}: Props) => {
    return (
        <Typography variant="xs" color="ds.fg.positive.secondary">
            Save{' '}
            <strong>
                {isLoading ? (
                    <Skeleton
                        variant="text"
                        height={lineHeightValues['xs']}
                        width={20}
                        sx={{ display: 'inline-block' }}
                    />
                ) : (
                    formatPriceWithCurrency(discount, currency)
                )}
                /year
            </strong>
        </Typography>
    );
};
